export default __webpack_public_path__ + "static/media/coresanscr75it-webfont.90cf496f.woff";